export const GET_SUMMARY_STATISTIC = 'GET_SUMMARY_STATISTIC';
export const GET_EARNINGS_STATISTIC = 'GET_EARNINGS_STATISTIC';
